import axios from "axios";
import qs from "qs";
import Vant, { Lazyload, Toast } from "vant";

//app相关开始
//获取签名方法
var url = "//zhuzhan.ijiangyin.com/siteapp/appClient/sign";
var appId = "2312";
function getSign(fun) {
  /*请求参数*/
  var paramObj = {
    httpUrl: url,
    type: "post",
    data: {
      appId: appId
    }
  };
  /*请求调用*/
  httpRequest(paramObj, fun, function() {
    alert("获取签名失败错误");
  });
}
function httpRequest(paramObj, fun, errFun) {
  var xmlhttp = null;
  /*创建XMLHttpRequest对象，
   *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
   * */
  if (window.XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest();
  } else if (window.ActiveXObject) {
    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
  }
  /*判断是否支持请求*/
  if (xmlhttp == null) {
    alert("你的浏览器不支持XMLHttp");
    return;
  }
  /*请求方式，并且转换为大写*/
  var httpType = (paramObj.type || "GET").toUpperCase();
  /*数据类型*/
  var dataType = paramObj.dataType || "json";
  /*请求接口*/
  var httpUrl = paramObj.httpUrl || "";
  /*是否异步请求*/
  var async = paramObj.async || true;
  /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
  var paramData = paramObj.data || [];
  var requestData = "";
  for (var name in paramData) {
    requestData += name + "=" + paramData[name] + "&";
  }
  requestData =
    requestData == "" ? "" : requestData.substring(0, requestData.length - 1);
  console.log(requestData);
  /*请求接收*/
  xmlhttp.onreadystatechange = function() {
    if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
      /*成功回调函数*/
      //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
      console.log("获取签名数据成功:" + xmlhttp.responseText);
      var obj = JSON.parse(xmlhttp.responseText);
      var data = obj.data;
      fun({
        timestamp: data.timestamp,
        sign: data.appSign
      });
    } else {
      /*失败回调函数*/
      errFun;
    }
  };
  /*接口连接，先判断连接类型是post还是get*/
  if (httpType == "GET") {
    xmlhttp.open("GET", httpUrl, async);
    xmlhttp.send(null);
  } else if (httpType == "POST") {
    xmlhttp.open("POST", httpUrl, async);
    //发送合适的请求头信息
    xmlhttp.setRequestHeader(
      "Content-type",
      "application/x-www-form-urlencoded"
    );
    xmlhttp.send(requestData);
  }
}

function queryUserInfoBasic() {
  //获取普通信息
  let userinfo = new Promise((resolve, reject) => {
    getSign(function(sign) {
      zjyapi.queryUserInfoBasic({
        sign: sign,
        params: {
          type: "1"
        },
        success: function(ret) {
          //console.log('获取用户信息成功：'+ ret);
          var data = JSON.parse(ret);
          if (data.uid) {
            sessionStorage.setItem("uid", data.uid);
            sessionStorage.setItem("mobile", data.mobile);
            axios({
              method: "post",
              url: "/api/member/login_app",
              data: qs.stringify({
                zjyuid: data.uid,
                mobile: data.mobile
              })
            }).then(res => {
              console.log("login_app");
              //console.log(res.data);
              if (res.data.code == 0) {
                console.log("comm.js存储了数据");
                sessionStorage.setItem("wmtoken", res.data.data.token);
                sessionStorage.setItem("wmmember", res.data.data);
                // location.reload();
              } else {
                //Toast(res.data.msg);
              }
              resolve(res.data);
            });
          } else {
            alert("请登录app");
          }
          console.log(ret);
          console.log(JSON.parse(ret));
        },
        error: function(error) {
          console.log("获取用户信息失败：" + JSON.stringify(error));
          reject(error);
        }
      });
    });
  });
  return userinfo;
}
function queryLocation() {
  let location = new Promise((resolve, reject) => {
    getSign(function(sign) {
      zjyapi.queryLocation({
        params: {
          type: "1" // type=1  是否要打开GPS定位,未打开弹出提示打开GPS
        },
        sign: sign,
        success: function(ret) {
          resolve(JSON.parse(ret));
          //alert("获取当前经纬度-成功返回:" + JSON.stringify(ret));
        },
        error: function(error) {
          alert("获取当前经纬度-调用失败:" + JSON.stringify(error));
          reject(error);
        }
      });
    });
  });
  return location;
}
//end
//app相关结束
export { queryUserInfoBasic, queryLocation };



// WEBPACK FOOTER //
// ./src/assets/js/common.js